import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";

/**
 * 解绑用户设备接口的请求参数
 */
export interface IUnbindUserDeviceParams extends IRequestParams {
    /**
     * 设备唯一ID
     */
    device_id: string;
}

/**
 * 解绑用户设备接口的返回结果
 */
export interface IUnbindUserDeviceResult extends IResultContent {
    is_ok: boolean;
    msg: string;
}

/**
 * 解绑用户设备
 * @param opts 请求选项
 * @returns 解绑结果
 */
export async function unbindUserDevice(opts: IRequestOptions<IUnbindUserDeviceParams>) {
    const res = await request<IUnbindUserDeviceResult>(
        tms.TUserDevice,
        tms.MUserDeviceUnbindUser,
        opts.params,
        opts.gateway,
        opts.handler
    );
    return res;
}

export default unbindUserDevice;
